import React from 'react';
import { Switch } from '@/shared/components/ui';
import type { ProjectInternalNotifyConfig } from '../../../types';

export interface NotifyInternalFieldsProps {
  value: ProjectInternalNotifyConfig;
  onChange: (key: keyof ProjectInternalNotifyConfig, val: boolean) => void;
  /** Prefixo dos data-testid (default `project-notify-internal`). */
  testIdPrefix?: string;
}

/**
 * Campos de "Notificações internas" — switches de alerta para a equipe.
 * Presentacional, reutilizado no formulário de criação e na aba de config.
 */
export const NotifyInternalFields: React.FC<NotifyInternalFieldsProps> = ({
  value,
  onChange,
  testIdPrefix = 'project-notify-internal',
}) => (
  <div className="space-y-4">
    <div data-testid={`${testIdPrefix}-unblocked`}>
      <Switch
        label="Tarefa liberada"
        description="Notificar o responsável quando os predecessores concluírem"
        checked={value.unblocked}
        onChange={(checked) => onChange('unblocked', checked)}
      />
    </div>
    <div data-testid={`${testIdPrefix}-completed`}>
      <Switch
        label="Tarefa concluída"
        description="Notificar o líder do projeto a cada conclusão"
        checked={value.completedLeader}
        onChange={(checked) => onChange('completedLeader', checked)}
      />
    </div>
    <div data-testid={`${testIdPrefix}-overdue`}>
      <Switch
        label="Tarefa atrasada"
        description="Notificar o líder quando uma tarefa passar do prazo"
        checked={value.overdue}
        onChange={(checked) => onChange('overdue', checked)}
      />
    </div>
  </div>
);

NotifyInternalFields.displayName = 'NotifyInternalFields';
